export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14793.f66e61e1.jpg";